import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "category/education",
  "use": "category/education-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"category/education\"><clipPath id=\"category/education_a\"><path d=\"M0 0h24v24H0z\" /></clipPath><g clip-path=\"url(#category/education_a)\"><path d=\"M24.15 6.72L12.07 0 0 6.72l1.77 1v13L0 24.1h5l-1.73-3.41V8.54l1.63.91v6.36c0 2.11 3.41 4 7.15 4s7.15-1.92 7.15-4V9.48zm-12.08-5l9 5-9 5-9-5zm5.63 14.09c0 .87-2.39 2.53-5.65 2.53S6.4 16.68 6.4 15.81v-5.52l5.67 3.15 5.63-3.13z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol